module.exports = __webpack_public_path__ + "img/6_115.a034d33c.png";